// extracted by mini-css-extract-plugin
export var emailInputBubbleContainer = "_ja-0";